import { Input } from '@/shared/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/components/ui/select'
import { CharacterVariant } from '@storyverse/shared'
import { FormField } from './FormField'
import React from 'react'

interface VariantIdentityTabProps {
    variant: CharacterVariant
    updateVariant: (id: string, updates: Partial<CharacterVariant>) => void
}

export const VariantIdentityTab: React.FC<VariantIdentityTabProps> = ({ variant, updateVariant }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 pt-4">
            <FormField label="Age" helperText="Current age in this variant.">
                <Input
                    value={variant.age || ''}
                    onChange={e => updateVariant(variant.id, { age: e.target.value })}
                    className="h-10"
                />
            </FormField>
            <FormField label="Role" helperText="Function in the story.">
                <Select
                    value={variant.role}
                    onValueChange={val => updateVariant(variant.id, { role: val as any })}
                >
                    <SelectTrigger className="h-10"><SelectValue /></SelectTrigger>
                    <SelectContent>
                        {['Protagonist', 'Antagonist', 'Deuteragonist', 'Supporting', 'Minor'].map(r => (
                            <SelectItem key={r} value={r}>{r}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </FormField>
            <FormField label="Occupation" helperText="Job or role in society.">
                <Input
                    value={variant.occupation || ''}
                    onChange={e => updateVariant(variant.id, { occupation: e.target.value })}
                    className="h-10"
                />
            </FormField>
            <FormField label="Key Relationships" helperText="Ties to other characters.">
                <Input
                    value={variant.relationships || ''}
                    onChange={e => updateVariant(variant.id, { relationships: e.target.value })}
                    className="h-10"
                />
            </FormField>
        </div>
    )
}
